import { NavLink } from '../ui';
import styles from './DesignCategory.module.css';
import { IDiWidget } from '@/interfaces';
import { useGlobalContext } from '@/lib/context';
import { useState } from 'react';

type props = {
    widgetData: IDiWidget
}

export function DesignWidget({ widgetData }: props) {
    const { props: { countryCode,pageURL } } = useGlobalContext();
    const _widgetData = widgetData?.data || null;
    const [active, setActive] = useState(0);
    if (!_widgetData || _widgetData.length === 0) return null;

    const siteURL = process.env.SITE_URL + "/" + countryCode;
    return (
        <div className={`${styles.iterationMbox}`}>
            <div className={styles.iterationsUper}>
                <h3 className={`mb12 f500 text222 lineHeight30 textSMcenter fontSM20 textCaptlise ${styles.heading}`}>{widgetData.heading}</h3>
                <ul className='scrollBarHide'>
                    {_widgetData.length > 0 && _widgetData.map((f, idx) =>
                        <li className={`${active === idx ? styles.active : ""} textCaptlise`} key={idx} onClick={() => setActive(idx)}>{f.attrName}</li>
                    )}
                </ul>
            </div>

            {_widgetData.map((f, idx) =>
                <div className={active === idx ? styles.iteratedloList : 'displayNone'} key={idx}>
                    <ul>
                        {f?.attrsData?.filter((a) => `${siteURL}/${a.url}` != pageURL)?.map((m, idx) =>
                            <li className='textCaptlise' key={idx}>
                                <NavLink href={`${siteURL}/${m.url}`} className={styles.widgitList} >
                                    {m.name}
                                </NavLink>
                            </li>
                        )}
                    </ul>
                </div>
            )}

        </div>
    )
}